export const setMCQContext = (data) => {
  localStorage.setItem("mcqContext", JSON.stringify(data));
};

export const getMCQContext = () => {
  return JSON.parse(localStorage.getItem("mcqContext")) || {};
};

export const clearMCQContext = () => {
  localStorage.removeItem("mcqContext");
};